import { render } from "./ShoppingCartPage.vue?vue&type=template&id=a212232a"
import script from "./ShoppingCartPage.vue?vue&type=script&lang=js"
export * from "./ShoppingCartPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__